import axiosInstance from "./Interceptor";

export const getHistoricDataServ = async (payload) => {
    try {
        const response = await axiosInstance.get('/historical_data', {
            params : {
                ...payload
            }
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const getMarketCapServ = async () => {
    try {
        const response = await axiosInstance.get('/market_cap');
        return response?.data;
    } catch (error) {
        throw error;
    }
}
export const getSearchTickerServ = async (payload) => {
    try {
        const response = await axiosInstance.get('/search_ticker', {
            params: {
                ...payload
            }
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const getFavouritesServ = async (payload) => {
    try {
        const response = await axiosInstance.get('/favourites', {
            params: {
                ...payload
            }
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const getBondsServ = async () => {
    try {
        const response = await axiosInstance.get('/bonds_data');
        return response?.data;
    } catch (error) {
        throw error;
    }
}